// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'
import { sync } from 'vuex-router-sync'
// import jwtDecode from 'jwt-decode'
import Vuelidate from 'vuelidate'
import {ServerTable, ClientTable} from 'vue-tables-2'
import VueI18n from 'vue-i18n'
import routes from './routes'
import store from './store'
// import config from './config'
import messages from './i18n'
import HeaderIndex from '../src/components/views/HeaderIndex.vue'
import Footer from '../src/components/views/FooterIndex.vue'
import IndexSelect from '../src/components/views/IndexSelect.vue'
// Import Helpers for filters
import { domain, count, prettyDate, pluralize } from './filters'

// Import Views - Top level
import AppView from './components/App.vue'

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)

Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(ServerTable)
Vue.use(ClientTable)
Vue.use(VueI18n)
Vue.component('HeaderIndex', HeaderIndex)
Vue.component('Footer', Footer)
Vue.component('IndexSelect', IndexSelect)
const isDebugMode = process.env.NODE_ENV !== 'production'
Vue.config.debug = isDebugMode
Vue.config.devtools = isDebugMode

// Routing logic
const router = new VueRouter({
    routes: routes,
    mode: 'history',
    scrollBehavior: function (to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 }
    }
})
window.addEventListener('beforeunload',
    () => {
        window.scrollTo({
            top: 0,
            left: -1,
            behavior: 'instant'
        })
        document.body.scrollTop = 0
    })
// const clearUserAndToken = function (to, next) {
//     store.commit('SET_USER', null)
//     store.commit('SET_TOKEN', null)
//     if (window.localStorage) {
//         window.localStorage.setItem('user', null)
//         window.localStorage.setItem('token', null)
//     }
//     next({
//         path: {name: 'login'},
//         query: { redirect: to.fullPath }
//     })
// }
let isListAppFunc = function (next) {
    // if (sessionStorage.registeredDetail === undefined || !localStorage.token || localStorage.token === 'null') {
    //     console.log('异步权限管理')
    //     // 异步权限管理
    //     setTimeout(() => {
    //         next({name: 'userLogin'})
    //     }, 10)
    // } else {
    next()
    store.state.borderStyle = 'file'
    localStorage.setItem('clickState', 'file')
    // }
}
let determineRouting = function (funcRouter, next, from) {
    let pathUrl = window.location.href
    if (pathUrl.indexOf('user/account/resetPassword') !== -1) {
        store.state.borderStyle = null
        localStorage.setItem('clickState', null)
        return
    }
    switch (funcRouter.name) {
        case 'listApp':
            let fromNames = ['sdkDescription', 'listMotionFile']
            for (let i = 0; i < fromNames.length; i++) {
                if (from.name === fromNames[i]) {
                    store.state.isSideBarShow = 0
                    sessionStorage.isSideBarShow = 0
                }
            }
            isListAppFunc(next)
            break
        case 'introduces':
            next({
                path: { name: 'introduces' }
            })
            store.state.borderStyle = 'developmentPlan'
            localStorage.setItem('clickState', 'developmentPlan')
            break
        case 'userLogin':
            console.log('login')
            next({
                path: { name: 'userLogin' }
            })
            store.state.borderStyle = 'login'
            localStorage.setItem('clickState', 'login')
            break
        case 'sdkDescription':
            isListAppFunc(next)
            store.state.isSideBarShow = 'sdk'
            sessionStorage.isSideBarShow = 'sdk'
            break
        case 'listMotionFile':
            isListAppFunc(next)
            store.state.isSideBarShow = 'motion'
            sessionStorage.isSideBarShow = 'motion'
            break
        case 'newIndex':
            next({
                path: { name: 'newIndex' }
            })
            store.state.borderStyle = null
            localStorage.setItem('clickState', null)
            break
        default:
            store.state.borderStyle = null
            localStorage.setItem('clickState', null)
    }
}
// // Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
    // window.console.log('Tran/sition', transition)
    document.body.scrollTop = document.documentElement.scrollTop = 0
    determineRouting(to, next, from)
    // if (to.meta.requiresAuth && window.localStorage && window.localStorage.getItem('token') === 'null') {
    //     window.console.log('Not authenticated')
    //     if (to && to.path.match(/^\/developerAdmin/i)) {
    //         next({
    //             name: 'login'
    //         })
    //     } else if (to && to.path.match(/^\/developerUser/i)) {
    //         next({
    //             name: 'userLogin'
    //         })
    //     }
    // } else if (to.meta.requiresAuth) {
    //     let token
    //     let bearerToken
    //     let user
    //     if (window.localStorage && window.localStorage.getItem('token') !== 'null' && window.localStorage.getItem('token') !== null) {
    //         token = window.localStorage.getItem('token')
    //         bearerToken = token
    //         user = window.localStorage.getItem('user')
    //     } else if (to.query && to.query.access_token) {
    //         token = to.query.access_token
    //         bearerToken = 'Bearer ' + token
    //     } else {
    //         if (to && to.path.match(/^\/developerAdmin/i)) {
    //             next({
    //                 path: {name: 'login'},
    //                 query: { redirect: to.fullPath }
    //             })
    //         } else if (to && to.path.match(/^\/developerUser/i)) {
    //             next({
    //                 path: {name: 'userLogin'},
    //                 query: { redirect: to.fullPath }
    //             })
    //         }
    //     }
    //     try {
    //         const decoded = jwtDecode(token)
    //         const exp = decoded.exp * 1000
    //         const now = new Date().getTime()
    //         if (exp < now || decoded.iss !== config.env[location.hostname.split('.')[0]].adminApiDomain) {
    //             clearUserAndToken(to, next)
    //         } else {
    //             store.commit('SET_USER', user)
    //             store.commit('SET_TOKEN', bearerToken)
    //             if (window.localStorage) {
    //                 window.localStorage.setItem('token', bearerToken)
    //             }
    //             // 跳转查询
    //             if (to.meta.requireAdmin) {
    //                 if (decoded.scope.indexOf('developer_admin') > -1) {
    //                     next()
    //                 } else {
    //                     next({
    //                         name: 'listApp'
    //                     })
    //                 }
    //             } else {
    //                 if (decoded.scope.indexOf('developer_admin') > -1) {
    //                     clearUserAndToken(to, next)
    //                     next({
    //                         name: 'userLogin'
    //                     })
    //                 } else {
    //                     next()
    //                 }
    //             }
    //         }
    //     } catch (err) {
    //         clearUserAndToken(to, next)
    //     }
    // } else {
    //     let token
    //     let bearerToken
    //     let user
    //     if (window.localStorage && window.localStorage.getItem('token') !== 'null' && window.localStorage.getItem('token') !== null) {
    //         token = window.localStorage.getItem('token')
    //         bearerToken = token
    //         user = window.localStorage.getItem('user')
    //     } else if (to.query && to.query.access_token) {
    //         token = to.query.access_token
    //         bearerToken = 'Bearer ' + token
    //     }
    //     try {
    //         if (token) {
    //             const decoded = jwtDecode(token)
    //             const exp = decoded.exp * 1000
    //             const now = new Date().getTime()
    //             if (exp < now || decoded.iss !== config.env[location.hostname.split('.')[0]].adminApiDomain) {
    //                 clearUserAndToken(to, next)
    //             } else {
    //                 store.commit('SET_USER', user)
    //                 store.commit('SET_TOKEN', bearerToken)
    //                 if (window.localStorage) {
    //                     window.localStorage.setItem('token', bearerToken)
    //                 }
    //             }
    //         }
    //     } catch (err) {
    //         clearUserAndToken(to, next)
    //     }

    //     if (to && (to.path === '/developerAdmin' || to.path === '/developerAdmin/')) {
    //         next({
    //             name: 'listUser'
    //         })
    //     } else if (to && (to.path === '/developerUser' || to.path === '/developerUser/')) {
    //         next({
    //             name: 'listApp'
    //         })
    //     } else {
    //         next()
    //     }
    // }
})

sync(store, router)

const i18n = new VueI18n({
    locale: 'zh-TW', // set locale
    messages // set locale messages
})
// Start out app!
// eslint-disable-next-line no-new
new Vue({
    i18n,
    el: '#root',
    router: router,
    store: store,
    render: h => h(AppView)
})

// Check local storage to handle refreshes
if (window.localStorage) {
    const localUser = window.localStorage.getItem('user') || 'null'
    // console.log(localUser)
    if (localUser && store.state.user !== localUser) {
        store.commit('SET_USER', localUser)
        store.commit('SET_TOKEN', window.localStorage.getItem('token'))
    }
}



// WEBPACK FOOTER //
// ./src/main.js